import { colors } from '@material-ui/core'

import theme from 'theme'

const PENDING_ID = 'pending'
const IN_PROGRESS_ID = 'in_progress'
const OVERDUE_ID = 'overdue'
const TREATED_ID = 'treated'
const RISK_ASSUMED_ID = 'risk_assumed'
const INACTIVE_ID = 'inactive'
const SOFT_DELETED_ID = 'soft_deleted'

const STATUS = {
  PENDING_ID,
  IN_PROGRESS_ID,
  OVERDUE_ID,
  TREATED_ID,
  RISK_ASSUMED_ID,
  INACTIVE_ID,
  SOFT_DELETED_ID,
}

const PENDING_LABEL = 'Pendente'
const IN_PROGRESS_LABEL = 'Em andamento'
const OVERDUE_LABEL = 'Atrasado'
const TREATED_LABEL = 'Tratado'
const RISK_ASSUMED_LABEL = 'Risco assumido'
const INACTIVE_LABEL = 'Inativo'

const STATUS_LABELS = {
  PENDING_LABEL,
  IN_PROGRESS_LABEL,
  OVERDUE_LABEL,
  TREATED_LABEL,
  RISK_ASSUMED_LABEL,
  INACTIVE_LABEL,
}

const STATUS_ITEMS = [
  { id: PENDING_ID, label: PENDING_LABEL },
  { id: IN_PROGRESS_ID, label: IN_PROGRESS_LABEL },
  { id: OVERDUE_ID, label: OVERDUE_LABEL },
  { id: TREATED_ID, label: TREATED_LABEL },
  { id: RISK_ASSUMED_ID, label: RISK_ASSUMED_LABEL },
  { id: INACTIVE_ID, label: INACTIVE_LABEL },
]

const CHIP_STATUS_TEXT_COLOR = {
  [PENDING_ID]: '#FF9800',
  [IN_PROGRESS_ID]: '#007bff',
  [OVERDUE_ID]: '#E53935',
  [TREATED_ID]: '#4CAF50',
  [RISK_ASSUMED_ID]: colors.purple[800],
  [INACTIVE_ID]: theme.palette.common.white,
}

const CHIP_STATUS_COLOR = {
  [PENDING_ID]: '#FFF3E0',
  [IN_PROGRESS_ID]: '#087DF138',
  [OVERDUE_ID]: '#FEEBEE',
  [TREATED_ID]: '#E8F5E9',
  [RISK_ASSUMED_ID]: colors.purple[100],
  [INACTIVE_ID]: colors.grey[500],
}

const CHIP_STATUS_LABEL = {
  [PENDING_ID]: PENDING_LABEL,
  [IN_PROGRESS_ID]: IN_PROGRESS_LABEL,
  [OVERDUE_ID]: OVERDUE_LABEL,
  [TREATED_ID]: TREATED_LABEL,
  [RISK_ASSUMED_ID]: RISK_ASSUMED_LABEL,
  [INACTIVE_ID]: INACTIVE_LABEL,
}

export default {
  STATUS,
  STATUS_LABELS,
  STATUS_ITEMS,
  CHIP_STATUS_TEXT_COLOR,
  CHIP_STATUS_COLOR,
  CHIP_STATUS_LABEL,
}
